import * as React from "react";
import styled from "styled-components";
import infoIcon from "src/assets/icons/information.svg";

const EditedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #f2f2f2;
  border-radius: 4px;
  padding-top: 10px;
  padding-left: 12px;
  padding-right: 16px;
  padding-bottom: 10px;
`;

const EditedText = styled.span`
  line-height: 18px;
  font-size: 14px;
  color: #4f4f4f;
`;

interface props {
  text?: string;
}

const EditedInfo = (props: props) => {
  return (
    <EditedContainer>
      <img src={infoIcon} style={{ marginRight: 16 }} alt="info-icon" />
      <EditedText>{props.text}</EditedText>
    </EditedContainer>
  );
};

export default EditedInfo;



// WEBPACK FOOTER //
// ./src/pages/MatchPage/components/EditedInfo.tsx